module.exports = __webpack_public_path__ + "img/west-vvip-gal-16.1424a673.jpg";